
//AJAX endpoints list
var mantlroutes = {
    api_badge: "/badge/:badgeid",

    user_home_view: "/myhome",
    institution_home_view: "/institution",

    verifications_all: "/allverifications", //staff only
    verifications_pending: "/pendingverifications", //staff only

    user_global_lookup: "/users/metrics",
    user_user: "/user",
    user_profile: "/userprofile",
    user_profile_update: "/userprofile/:profileid",
    user_profile_accounts: "/userprofile/:profileid/accounts",
    user_membership_open: "/user/:userid/membership/open",
    user_membership: "/user/:userid/membership/",
    user_programs: "/user/:userid/programs",
    user_programs_open: "/user/:userid/programs/open",
    user_order_summary: "/checkout/user-order-summary",

    badge_programs: "/badge/:badgeid/programs",

    org_order_summary: "/checkout/org-order-summary/:orgid",
    org_subscriptions: "/checkout/org-subscriptions/:orgid",

    org_new: "/org/new",
    org_new_child: "/org/:orgid/new",
    org_lookup_with_subs: "/org/lookup_with_subs",
    org_global_lookup: "/org/all",
    org_global_metrics: "/org/globalmetrics",
    org_list: "/org",
    org_about: "/org/:orgid",
    org_about_view: "/org/:orgid/about",
    org_family: "/org/:orgid/family",
    org_verifications: "/org/:orgid/verification",
    org_verification: "/org/:orgid/verification/:verificationid", //staff only
    org_verification_notes: "/org/:orgid/verification/:verificationid/notes",
    org_verification_notes_list: "/org/:orgid/verification/:verificationid/note", //staff only
    org_verification_note: "/org/:orgid/verification/:verificationid/note/:noteid", //staff only

    org_invitations: "/org/:orgid/invitation",
    org_invitation: "/org/:orgid/invitation/:invitationid",
    org_open_domains: "/org/:orgid/opendomain/",
    org_open_domain: "/org/:orgid/opendomain/:domainid",
    org_members: "/org/:orgid/member/",
    org_member: "/org/:orgid/member/:userid",
    org_member_metrics: "/org/:orgid/member/metrics",
    org_view_member_metrics: "/org/:orgid/members/metrics",
    org_badges: "/org/:orgid/badge_library/",
    org_badges_import: "/org/:orgid/badge/import",
    org_badges_import_library: "/org/:orgid/badge/import/library",

    //badgebuilder api
    org_badgebuilder: "/org/:orgid/badgebuilder",
    org_badgebuilder_badge: "/org/:orgid/badgebuilder/:badgeid",
    org_badgebuilder_criteria: "/org/:orgid/badgebuilder/:badgeid/criterion",
    org_badgebuilder_criterion: "/org/:orgid/badgebuilder/:badgeid/criterion/:criterionid",
    org_badgebuilder_int_alignments: "/org/:orgid/badgebuilder/:badgeid/internal-alignment",
    org_badgebuilder_int_alignment: "/org/:orgid/badgebuilder/:badgeid/internal-alignment/:alignmentid",
    org_badgebuilder_ext_alignments: "/org/:orgid/badgebuilder/:badgeid/external-alignment",
    org_badgebuilder_ext_alignment: "/org/:orgid/badgebuilder/:badgeid/external-alignment/:alignmentid",
    //badgebuilder library to icons8
    // icon8_categories: "https://api.icons8.com/api/iconsets/categories",
    // icon8_category_icons: "https://api.icons8.com/api/iconsets/category",
    // icon8_search: "https://api.icons8.com/api/iconsets/search",
    icon8_search: "/badge/icons8/search",
    icon8_retrieve: "/badge/icons8/retrieve",
    //badge award apis
    badge_bulk_award: "/badge/:badgeid/bulkaward",
    badge_award: "/badge/:badgeid/award",
    badge_bulk_claim: "/badge/claim",

    //badge UI views
    org_badges_view: "/org/:orgid/badges/",
    org_create_badge: "/org/:orgid/badge/create",
    org_edit_badge: "/org/:orgid/badge/:badgeid/edit",
    org_view_badge: "/org/:orgid/badge/:badgeid",
    org_award_badge: "/org/:orgid/badge/:badgeid/award",
    org_assertions: "/org/:orgid/assertion",
    org_assertions_csv: "/org/:orgid/assertion/csv",
    org_view_assertion: "/org/:orgid/assertion/:assertionid/view",

    //engage api proxies
    org_engage_events: "/org/:orgid/engage/Events",
    org_engage_curriculums: "/org/:orgid/engage/Curriculums",
    //data lake, n.b. these use commons ids, not mantl org id
    datalake_institutions: "/data-lake/institutions",
    datalake_outcomes_outcomes: "/data-lake/outcomes/:institutionid/outcome",
    datalake_outcomes_timeperiods: "/data-lake/outcomes/:institutionid/time-period",
    datalake_outcomes_containers: "/data-lake/outcomes/:institutionid/container",

    //badge related models
    claim_codes: "/org/:orgid/badge/:badgeid/claimcodes",
    claim_code: "/org/:orgid/badge/:badgeid/claimcodes/:claimcodeid",
    org_badge_grants: "/org/:orgid/badge-grant",
    org_badge_grants_grant: "/org/:orgid/badge-grant/:grantid",
    org_badge_granted: "/org/:orgid/badge-granted",
    org_badge_granted_grant: "/org/:orgid/badge-granted/:grantid",

    org_outcomeset_list: "/org/:orgid/outcomeset",
    org_outcomeset: "/org/:orgid/outcomeset/:outcomesetid",
    org_outcome_list: "/org/:orgid/outcomeset/:outcomesetid/outcome",
    org_outcome: "/org/:orgid/outcomeset/:outcomesetid/outcome/:outcomeid",
    org_outcomes: "/org/:orgid/outcomes/",

    programs_allroles: "/org/:orgid/programroles/:userid/",
    programs: "/org/:orgid/program/",
    program: "/org/:orgid/program/:programid/",
    program_metrics: "/org/:orgid/program/:programid/analytics",
    program_items: "/org/:orgid/program/:programid/items",
    program_designer: "/org/:orgid/program/:programid/designer",
    program_preview: "/org/:orgid/program/:programid/preview",
    program_learners: "/org/:orgid/program/:programid/learner/",
    program_learners_item: "/org/:orgid/program/:programid/learner/:userid/",
    program_staff: "/org/:orgid/program/:programid/staff/",
    program_staff_item: "/org/:orgid/program/:programid/staff/:userid/",
    program_submissions: "/org/:orgid/program/:programid/submission/",
    program_submission_allowed: "/org/:orgid/program/:programid/submissionallowed/:badgeid/",
    program_submissions_view: "/org/:orgid/program/:programid/submissions/",
    program_assessments: "/org/:orgid/program/:programid/assessment/",
    program_assess: "/org/:orgid/program/:programid/assessmentmodal/:submissionid/",
    program_join_learner: "/org/:orgid/program/:programid/learner/join",

    bc_host_connections: "/badgeconnect/host-connection",
    bc_host_connection: "/badgeconnect/host-connection/:connectionid",
    bc_host_connection_assertions: "/badgeconnect/host-connection/:connectionid/assertion",
    bc_host_connection_profiles: "/badgeconnect/host-connection/:connectionid/profile",

    portfolio_theirs: "/theirhome/:portfolioid",
    portfolio_analytics: "/portfolio/:portfolioid/analytics",
    portfolio_shares: "/portfolio/share",
    portfolio_share_item: "/portfolio/share/:sharecode",
    portfolio_follows: "/portfolio/:portfolioid/follows", // lists all portfolio user follows, or adds a follower to a portfolio user
    portfolio_follow: "/portfolio/:portfolioid/follow", // retrieves viewers follow of this portfolio user. delete to unfollow
    portfolio_submissions: "/portfolio/:portfolioid/submission",
    portfolio_assessments: "/portfolio/:portfolioid/assessment",
    portfolio_collections: "/portfolio/:portfolioid/collection",
    portfolio_work: "/portfolio/:portfolioid/work",
    portfolio_collection_work: "/portfolio/:portfolioid/collection/:collectionid/work",
    portfolio_noncurated_work: "/portfolio/:portfolioid/noncuratedwork/",
    portfolio_badges: "/portfolio/:portfolioid/badge",
    portfolio_collection_badges: "/portfolio/:portfolioid/collection/:collectionid/badge",
    portfolio_noncurated_badges: "/portfolio/:portfolioid/noncuratedbadge/",
    portfolio_skills: "/portfolio/:portfolioid/skill",
    portfolio_collection_skills: "/portfolio/:portfolioid/collection/:collectionid/skill",
    portfolio_noncurated_skills: "/portfolio/:portfolioid/noncuratedskill/",
    portfolio_endorsements: "/portfolio/:portfolioid/endorsement",
    portfolio_collection_endorsements: "/portfolio/:portfolioid/collection/:collectionid/endorsement",
    portfolio_noncurated_endorsements: "/portfolio/:portfolioid/noncuratedendorsement/",
    portfolio_timeline: "/portfolio/:portfolioid/timelineevent",
    portfolio_timeline_event: "/portfolio/:portfolioid/timelineevent/:eventid",
    portfolio_event_create: "/portfolio/:portfolioid/eventcreate",
    portfolio_goal_list: "/portfolio/:portfolioid/goal",
    portfolio_goal: "/portfolio/:portfolioid/goal/:goalid",
    portfolio_goal_comment_list: "/portfolio/:portfolioid/goal/:goalid/comment",
    portfolio_goal_comment: "/portfolio/:portfolioid/goal/:goalid/comment/:commentid",
    portfolio_goal_skills_all: "/portfolio/:portfolioid/goalskill",
    portfolio_goal_skills: "/portfolio/:portfolioid/goalskill/:goalid",

    portfolio_jobsearch: "/jobsearch",
    portfolio_jobdetails: "/jobdetails",

    skill_list: "/portfolio/skill",

    career_list: "/portfolio/career", // model deleted
    career_skills: "/portfolio/career/:careerid", // model deleted

    occupation_onet_list: "/occupation/onet",
    occupation_onet_retrieve: "/occupation/onet/:onetid",
    occupation_list: "/occupation",
    occupation_retrieve: "/occupation/:occupationid",
    occupation_starters: "/occupation/:occupationid/starters",
    occupation_changers: "/occupation/:occupationid/changers",
    occupation_ksa_list: "/occupation/ksa",
    occupation_ksa_retrieve: "/occupation/ksa/:ksaid",
    occupation_tech: "/occupation/tech",

    //note that endorsement_* relates to open badge endorsements, not the portfolio endorsements
    endorsement_create_modal: "/badge/:endorseetype/:endorseeid/endorse",
    endorsement_create: "/badge/:endorseetype/:endorseeid/:endorsertype/:endorserid/endorsement",
    endorsement_list: "/badge/:endorseetype/:endorseeid/endorsement",
    endorsement_item_crud: "/badge/:endorseetype/:endorseeid/:endorsertype/:endorserid/endorsement/:endorsementid",
    endorsement_item: "/badge/:endorseetype/:endorseeid/endorsement/:endorsementid",
    //ob endorsement for third party uploaded badges
    ext_endorsement_create_modal: "/bakedbadge/:endorseetype/:endorseeid/endorse",
    ext_endorsement_create: "/bakedbadge/:endorseetype/:endorseeid/:endorsertype/:endorserid/endorsement",
    ext_endorsement_list: "/bakedbadge/:endorseetype/:endorseeid/endorsement",
    ext_endorsement_item_crud: "/bakedbadge/:endorseetype/:endorseeid/:endorsertype/:endorserid/endorsement/:endorsementid",
    ext_endorsement_item: "/bakedbadge/:endorseetype/:endorseeid/endorsement/:endorsementid",



    blank: ""
}


function bindRouteLinks(){
    $("a[data-method],button[data-method]").off('click').on('click',function(event){
        console.log("route link caught")
        event.preventDefault();
        var route = $(this).attr("href");
        var verb = $(this).attr("data-method");
        verb = verb.toLowerCase();
        if(verb.length > 0){
            switch(verb) {
                case "post":
                    httpPost(route).then(
                        function(value) {
                            var response = JSON.parse(value);
                            console.log(response);
                        })
                    .catch(
                        function(reason) {
                            console.error('POST failure from ' + event.target, reason);
                            alertify.error('Unable to Post Data')
                        });
                    break;
                case "put":
                    httpPut(route).then(
                        function(value) {
                            var response = JSON.parse(value);
                            console.log(response);
                        })
                    .catch(
                        function(reason) {
                            console.error('PUT failure from ' + event.target, reason);
                            alertify.error('Unable to Update Data')
                        });
                    break;
                case "patch":
                    httpPatch(route).then(
                        function(value) {
                            var response = JSON.parse(value);
                            console.log(response);
                        })
                    .catch(
                        function(reason) {
                            console.error('PATCH failure from ' + event.target, reason);
                            alertify.error('Unable to Update Data')
                        });
                    break;
                case "delete":
                    httpDelete(route).then(
                        function(value) {
                            var response = JSON.parse(value);
                            console.log(response);
                        })
                    .catch(
                        function(reason) {
                            console.error('DELETE failure from ' + event.target, reason);
                            alertify.error('Unable to Delete Data')
                        });
                    break;
            }
        }

    });
}


//Build path using keyed params
//e.g. "/org/:orgid/program/:programid/"
function buildRoute(path,params,version,no_prefix){
    var version = version | "20";
    if(path == undefined){
        throw 'Path pattern undefined for route.'
    }
    if(path.indexOf(":") > -1) {
        if(params == undefined){
            throw 'Path params undefined for route.'
        }
        for (var prop in params) {
            path = path.split(":" + prop).join(params[prop]);
        }
    }
    path = "/api/v" + version + path;
    if ( ! no_prefix ) {
        path = mantl.prefix_path(path);
    }
    return path;
}

//Build view is a flavour to avoid any future conflicts with api version roots on paths
function buildView(path,params,no_prefix){
    if(path == undefined){
        throw 'Path pattern undefined for route.'
    }
    if(path.indexOf(":") > -1) {
        if (params == undefined) {
            throw 'Path params undefined for route.'
        }
        for (var prop in params) {
            path = path.split(":" + prop).join(params[prop]);
        }
    }
    if ( ! no_prefix ) {
        path = mantl.prefix_path(path);
    }
    return path;
}

function formatParams( params ){
    var cleaned = clean(params);//setting params to null allows us to ignore them. useful when dealing with react inheritance of state;
    return "?" + Object
        .keys(cleaned)
        .map(function(key){
            if (cleaned[key] instanceof Array) {
                var params = [];
                for(var i = 0; i < cleaned[key].length; i++){
                    params.push(key+"="+cleaned[key][i]);
                }
                return params.join("&");
            } else {
                return key+"="+cleaned[key];
            }
        })
        .join("&")
}

function clean(obj) {
    var cleaned = $.extend(true,{}, obj);
    for (var propName in cleaned) {
        // if (cleaned[propName] === null || cleaned[propName] === undefined) {
        if (cleaned[propName] === null || cleaned[propName] === undefined || cleaned[propName] === "") {
            delete cleaned[propName];
        }
    }
    return cleaned;
}

function stringToBoolean(str){
    return str.toLowerCase() == "true";
}

//check if a value should be a boolean, not "true" or "false"
function cleanBooleanStrings(value){
    if(value.toLowerCase() == "true" || value.toLowerCase() == "false") {
        return stringToBoolean(value);
    } else {
        return value;
    }
}

//custom jquery serialization
(function($){
	$.fn.serializeObject = function () {
		"use strict";

		var result = {};
		var extend = function (i, element) {
			var node = result[element.name];
			if ('undefined' !== typeof node && node !== null) {
                if ($.isArray(node)) {
					node.push(element.value);
				} else {
					result[element.name] = [node, element.value];
				}
			} else {
				result[element.name] = element.value;
			}
		};

		$.each(this.serializeArray(), extend);
		return result;
	};
})(jQuery);


//Warning: ECMA 6 Promises used in httpVERB() functions. Requires polyfill for some browsers.
function httpGetExternal(url) { //external doesn't send csrftoken
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
					if (this.status === 200){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('GET', url);
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send();
        });
}

function httpGet(url, acceptHeader = 'application/json; indent=4, application/json, application/yaml, text/html, */*') {
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
					if (this.status === 200){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('GET', url);
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("X-Requested-With", "XMLHttpRequest"); //Django won't return true for is_ajax without this
            request.setRequestHeader("Accept", acceptHeader);
            request.send();
        });
}

function httpPostMulti(url,data) { //multipart
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
                    // console.log("httpPostMulti response",this);
					if (this.status === 200 || this.status === 201){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('POST', url);
			//request.setRequestHeader("Content-Type", "multipart/form-data"); //don't set this unless you manually set boundary
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send(data);
        });
}

function httpPatchMulti(url,data) { //multipart
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
                    //console.log("httpPostMulti response",this);
					if (this.status === 200 || this.status === 201){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('PATCH', url);
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send(data);
        });
}

function httpPost(url,data, json=true) { //assumes JSON
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
                    //console.log("httpPost response",this);
					if (this.status === 200 || this.status === 201){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('POST', url);
            if(!json){
                request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            }else{
                request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            }
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send(JSON.stringify(data));
        });
}

function httpPatch(url,data) { //assumes JSON
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
					if (this.status === 200 || this.status === 201){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('PATCH', url);
			request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send(JSON.stringify(data));
        });
}

function httpPut(url,data) { //assumes JSON
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
                    //console.log("httpPut response",this);
					if (this.status === 200 || this.status === 201){
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('PUT', url);
			request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send(JSON.stringify(data));
        });
}

function httpDelete(url) {
    return new Promise(
        function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
				var DONE = 4;
			    if (this.readyState === DONE){
					if (this.status === 200 || this.status === 202 || this.status === 204){
						// Success
				    	resolve(this.response);
					} else {
                        reject(this.response);
					}
                    handleXHR(this);
			    }
            }
            request.onerror = function () {
                reject(new Error(
                    'XMLHttpRequest Error: '+this.statusText));
            };
            request.open('DELETE', url);
            request.setRequestHeader("X-CSRFToken", getFieldValue('csrfmiddlewaretoken'));
            request.setRequestHeader("Accept", "application/json; indent=4, application/json, application/yaml, text/html, */*");
            request.send();
        });
}

function alertifyResponseObject(response, isError){
    var isError = isError || false;
    if(typeof response === 'object') {
        for(var prop in response) {
            try {
                // console.log(typeof response[prop]);
                //Check if the object is an array or messages
                if(Array.isArray(response[prop])) {
                    response[prop].forEach(function(element) {
                        alertifyResponseObject(element);
                    });
                } else {
                    var label = prop;
                    if(label == 'non_field_errors' && typeof response[prop] === 'string') {
                        label = 'Error';
                    }
                    label = label.replace(/_/g, ' ');
                    var msg = '<b class="text--capitalize">' + label + '</b>: ' + '<span>' + response[prop] + '</span>';
                    if(isError){
                        alertify.error(msg);
                    } else {
                        alertify.warning(msg);
                    }
                }
            }
            catch(err) {
                console.error('Unable to display response property alert.', prop, err)
            }
        }
    } else if (typeof response === 'string'){
        //string backup for badly formatted JSON
        try {
            if(isError){
                alertify.error(`<b class="text--capitalize">Error</b>: <span>${response}</span>`);
            } else {
                alertify.warning(`<b class="text--capitalize">Warning</b>: <span>${response}</span>`);
            }
        }
        catch(err) {
            console.error('Unable to display response property alert.', response, err)
        }
    }
}

function handleXHR(xhr){
    //console.log(xhr.responseText);
    //4×× Client Error
    if(xhr.status > 399 && xhr.status < 500){
        //response, responseText, status, statusText
        if(xhr.responseText.indexOf("<!DOCTYPE html>") != -1){
            var $modal = buildModal(xhr.responseText,{
                classes: 'modal modal--full',
                header: 'Application Error Manager'
            });
            $('body').append($modal);
            $modal.on("modal:close",function(){
                $modal.off("modal:close").remove();
            });
            $modal.openModal();
        } else {
            if(isJSON(xhr.responseText)){
                var response = JSON.parse(xhr.responseText);
                if(!Array.isArray(response)){ //we don't auto build notifications on array response since this is probably a form being processed
                    for(var prop in response) {
                        //sometimes apis throw back something like {'error':{ 'error':'msg'}}
                        if(typeof response[prop] === 'object') {
                            for(var nestedprop in response[prop]) {
                                alertifyResponseObject(response[prop], true);
                            }
                        } else {
                            alertifyResponseObject(response, true);
                        }
                    }
                }
            }
            console.error(xhr);
        }
    }
    //5×× Server Error
    if(xhr.status > 499 && xhr.status < 600){
        if(xhr.responseText.indexOf("<!DOCTYPE html>") != -1){
            var $modal = buildModal(xhr.responseText,{
                classes: 'modal modal--full',
                header: 'Application Error Manager'
            });
            $('body').append($modal);
            $modal.on("modal:close",function(){
                $modal.off("modal:close").remove();
            });
            $modal.openModal();
        } else {
            if(isJSON(xhr.responseText)){
                var response = JSON.parse(xhr.responseText);
                if(!Array.isArray(response)){ //we don't auto build notifications on array response since this is probably a form being processed
                    if(typeof response[prop] === 'object') {
                        for(var nestedprop in response[prop]) {
                            alertifyResponseObject(response[prop], true);
                        }
                    } else {
                        alertifyResponseObject(response, true);
                    }
                }
            }
            console.error(xhr);
        }

    }
}
